import React from 'react'

export const CheckVector = () => (
  <svg
    className="MIRECO-check"
    width="24"
    height="24"
    viewBox="0 0 6.35 6.35"
    style={{display: 'none'}}
  >
    <g transform="translate(0,-290.65)">
      <path
        style={{
          fill: 'none',
          strokeWidth: '1.0583',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: '4',
          strokeDasharray: 'none',
        }}
        d="M 1.588,294.090 2.646,295.148 4.763,292.237"
      />
    </g>
  </svg>
)
